// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  SORT_ORDERS: {
    ASC: {
      value: 'ASC',
      icon: 'icon-sort-name-up',
      headerIcon: 'icon-down-open'
    },
    DESC: {
      value: 'DESC',
      icon: 'icon-sort-name-down',
      headerIcon: 'icon-up-open'
    },
    Unsorted: {
      value: 'Unsorted',
      icon: 'icon-unsort'
    }
  },
  // report-part > field properties > function
  FIELD_FUNCTION_MODE: {
    FieldProperty: 0,
    SubTotal: 1,
    GrandTotal: 2
  },

  DEFAULT_FORMAT_BY_DATA_TYPE: {
    Time: 'HH:mm:ss'
  },

  DEFAULT_FORMAT_BY_FUNCTION_DATA_TYPE: {
    Datetime: {
      Group: 'Year'
    }
  },

  FUNCTION: {
    GROUP: {
      NAME: 'Group'
    },
    SUM: {
      NAME: 'Sum'
    },
    GROUP_DAYS_OLD: {
      NAME: 'Group Days Old'
    },
    COUNT: {
      NAME: 'Count'
    },
    NONE: {
      NAME: ''
    },
    DAYS_OLD: {
      NAME: 'Days Old'
    },
    MAXIMUM: {
      NAME: 'Maximum'
    },
    MINIMUM: {
      NAME: 'Minimum'
    }
  },

  EMPTY_FUNCTION: {
    id: null,
    name: ''
  },

  FORMAT_KEY: {
    MONTH: {
      NAME: 'Month'
    },
    YEAR: {
      NAME: 'Year'
    },
    NONE: '',
    DEFAULT_TIME: {
      NAME: 'HH:mm:ss'
    }
  },

  MESSAGES: {
    get M08() {
      return localizer.getText('COMMON_MESSAGES_MUST_BE_FUNCTION');
    },
    get M10() {
      return localizer.getText('REPORT_PART_FIELD_CONSTANTS_MESSAGES_NOT_ACCEPT_EMPTY_FUNCTION');
    }
  },

  ERROR_TYPE: {
    ERROR_MESSAGE: 'error',
    NOTIFY: 'notify'
  },

  CUSTOM_FORMAT_PREFIX: 'org_'
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportPartFieldConstants.js